export default __webpack_public_path__ + "static/media/folder-2.a1fb0228.png";